export interface GossipFaq {
  question: string;
  answer: string;
}

export const gossipFaqs: GossipFaq[] = [
  {
    question: "网报吃瓜里的「事件串」是什么意思？",
    answer:
      "事件串就是把同一个话题从最早出现、持续发酵、当事方回应到后续收尾的节点，按时间顺序排在同一条记录里。你打开一个事件的详情页，从上往下读一遍，就等于把整件事完整追完，不必再在几个平台之间来回翻。",
  },
  {
    question: "网报吃瓜汇总和网报吃瓜合集有什么区别？",
    answer:
      "汇总更强调范围，通常按天或按周把当期出现的热点收在一处，方便快速扫一遍；合集则围绕一个主题，把相关事件串整理成一组，适合想深入了解某条线索的人。事件库里两种形式都能找到，用分类筛选即可切换。",
  },
  {
    question: "站内的事件信息是实时更新的吗？",
    answer:
      "每个事件页都会标注「首次收录」和「最近整理」两个时间，凡是出现新节点，我们会在原事件串上追加记录，而不是另开一条。所以同一件事建议直接回到原页面看更新，信息更连续。",
  },
  {
    question: "热度数值是怎么来的？",
    answer:
      "热度是站内的一个相对参考值，综合了话题被提及的密度、持续天数和参与讨论的人数区间，只用来帮助排序，不代表任何真实统计口径，也不作为事实判断的依据。",
  },
  {
    question: "如果发现整理的内容有出入怎么办？",
    answer:
      "可以通过页面底部的联系方式把具体事件和疑问发给我们。我们会在核对公开信息后更新事件串，并在页面上标注补充说明。对于只存在于单一信源的猜测，我们通常不会收录为正式节点。",
  },
  {
    question: "网报吃瓜大全里会收录未经证实的传闻吗？",
    answer:
      "不会把传闻当成结论。对于尚未有明确回应的内容，我们会标注为「讨论中」，并在正文里说明信息来自哪些公开渠道，让读者自己判断，而不是替读者下结论。",
  },
];